(()=>{
  if(window.__vivaAskRevealGuard)return;
  window.__vivaAskRevealGuard=true;
  const init=()=>{
    const root=document.querySelector('[data-viva-ask-root]');if(!root)return;
    const results=root.querySelector('[data-viva-results]');if(!results)return;
    const authorized=()=>{
      const visual=root.querySelector('[data-viva-visualization]');
      const img=visual?.querySelector('img');
      return results.dataset.vivaVerifiedVisualReady==='1'&&visual?.dataset.vivaVerified==='1'&&img?.dataset.vivaVerified==='1'&&img.complete&&img.naturalWidth>0&&img.naturalHeight>0;
    };
    const enforce=()=>{if(!results.hidden&&!authorized())results.hidden=true;};
    enforce();
    new MutationObserver(enforce).observe(root,{childList:true,subtree:true,attributes:true,attributeFilter:['hidden','data-viva-verified-visual-ready','data-viva-verified']});
  };
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init,{once:true});else init();
})();
